/**
 * BrandsHero.tsx — Gold Garage Door / Brands · Section 1/8
 * Navy hero · "Every brand, expertly serviced" · floating logo cloud · 4-stat strip.
 * MOBILE: real <style> media queries (inline grid can't be overridden by Tailwind).
 * 10WEB AI: keep <img> + <style>. Wave dividers intentional — do NOT strip.
 */

const NAVY = "#081438";
const NAVY2 = "#0f2347";
const GOLD = "#F5A623";
const FLOAT_LOGOS = ["https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp", "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp"];
export default function BrandsHero() {
  const stats = [{
    val: "12+",
    label: "Brands serviced"
  }, {
    val: "All",
    label: "Parts in stock"
  }, {
    val: "217+",
    label: "Suburbs"
  }, {
    val: "5.0★",
    label: "Google rating"
  }];
  return <section id="brands-hero" style={{
    background: `radial-gradient(ellipse at 70% 0%, #1a2f5e 0%, ${NAVY} 60%)`,
    position: "relative",
    overflow: "hidden",
    paddingTop: "6rem",
    paddingBottom: "5rem"
  }}>
      <style>{`
        .bh-grid { display: grid; grid-template-columns: 1.1fr 0.9fr; gap: 3.5rem; align-items: center; }
        .bh-logocloud { display: grid; grid-template-columns: repeat(3, 1fr); gap: 0.85rem; }
        .bh-stats { display: grid; grid-template-columns: repeat(4, 1fr); }
        @media (max-width: 880px) {
          .bh-grid { grid-template-columns: 1fr; gap: 2.5rem; }
          .bh-logocloud { order: -1; max-width: 420px; }
          #brands-hero { padding-top: 4.5rem; }
        }
        @media (max-width: 520px) {
          .bh-stats { grid-template-columns: repeat(2, 1fr); row-gap: 1.25rem; }
          .bh-stats > div { border-right: none !important; padding-left: 0 !important; }
          .bh-logocloud { grid-template-columns: repeat(2, 1fr); }
        }
      `}</style>

      <svg aria-hidden style={{
      position: "absolute",
      inset: 0,
      width: "100%",
      height: "100%",
      opacity: 0.05,
      pointerEvents: "none"
    }}>
        <filter id="grain-bh"><feTurbulence type="fractalNoise" baseFrequency="0.65" numOctaves="3" stitchTiles="stitch" /><feColorMatrix type="saturate" values="0" /></filter>
        <rect width="100%" height="100%" filter="url(#grain-bh)" />
      </svg>

      <div aria-hidden style={{
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      right: "-2rem",
      bottom: "-3rem",
      fontSize: "18rem",
      fontWeight: 900,
      color: `${GOLD}0D`,
      fontFamily: "'Plus Jakarta Sans', sans-serif",
      lineHeight: 1,
      userSelect: "none",
      pointerEvents: "none"
    }}>GG</div>

      <div className="bh-grid" style={{
      maxWidth: "1200px",
      margin: "0 auto",
      padding: "0 1.5rem",
      position: "relative",
      zIndex: 1
    }}>
        {/* LEFT — copy */}
        <div>
          <div style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.5rem",
          background: `${GOLD}18`,
          border: `1px solid ${GOLD}40`,
          borderRadius: "9999px",
          padding: "0.375rem 1rem",
          marginBottom: "1.5rem"
        }}>
            <span style={{
            width: "6px",
            height: "6px",
            borderRadius: "50%",
            background: GOLD,
            display: "inline-block"
          }} />
            <span style={{
            color: GOLD,
            fontSize: "0.7rem",
            fontWeight: 700,
            letterSpacing: "0.12em",
            fontFamily: "'Manrope', sans-serif"
          }}>AUTHORISED-LEVEL EXPERTISE · SINCE 2009</span>
          </div>

          <h1 style={{
          fontFamily: "'Plus Jakarta Sans', sans-serif",
          fontWeight: 800,
          fontSize: "clamp(1.9rem, 7vw, 3.25rem)",
          lineHeight: 1.1,
          color: "#FFFFFF",
          marginBottom: "1.25rem"
        }}>
            Every brand on your<br />garage — <span style={{
            color: GOLD
          }}>expertly serviced</span>
          </h1>

          <p style={{
          fontFamily: "'Manrope', sans-serif",
          fontSize: "1.05rem",
          color: "rgba(255,255,255,0.78)",
          lineHeight: 1.7,
          marginBottom: "2rem",
          maxWidth: "480px"
        }}>
            B&D, Merlin, ATA, Centurion, Steel-Line and more. We carry the parts,
            know the systems, and repair or install every major garage-door brand
            across Sydney.
          </p>

          <div style={{
          display: "flex",
          gap: "1rem",
          flexWrap: "wrap"
        }}>
            <a href="tel:0485000933" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.875rem 1.75rem",
            background: `linear-gradient(135deg, ${GOLD}, #d4a017)`,
            color: NAVY,
            fontWeight: 700,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "0.95rem",
            boxShadow: `0 4px 20px ${GOLD}35`
          }}> 0485 000 933</a>
            <a href="#contact-us" style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0.5rem",
            padding: "0.875rem 1.75rem",
            background: "rgba(255,255,255,0.08)",
            border: "1px solid rgba(255,255,255,0.25)",
            color: "#FFFFFF",
            fontWeight: 600,
            fontFamily: "'Plus Jakarta Sans', sans-serif",
            borderRadius: "8px",
            textDecoration: "none",
            fontSize: "0.95rem"
          }}>Get a Free Quote</a>
          </div>

          <div className="bh-stats" style={{
          marginTop: "2.5rem",
          borderTop: "1px solid rgba(255,255,255,0.1)",
          paddingTop: "1.5rem"
        }}>
            {stats.map((s, i) => <div key={i} style={{
            paddingRight: "1rem",
            borderRight: i < 3 ? "1px solid rgba(255,255,255,0.1)" : "none",
            paddingLeft: i > 0 ? "1rem" : 0
          }}>
                <div style={{
              fontFamily: "'Plus Jakarta Sans', sans-serif",
              fontWeight: 800,
              fontSize: "1.5rem",
              color: GOLD,
              lineHeight: 1
            }}>{s.val}</div>
                <div style={{
              fontFamily: "'Manrope', sans-serif",
              fontSize: "0.72rem",
              color: "rgba(255,255,255,0.5)",
              marginTop: "0.25rem",
              textTransform: "uppercase",
              letterSpacing: "0.08em"
            }}>{s.label}</div>
              </div>)}
          </div>
        </div>

        {/* RIGHT — logo cloud */}
        <div className="bh-logocloud">
          {FLOAT_LOGOS.map((src, i) => <div key={i} style={{
          background: NAVY2,
          border: "1px solid rgba(255,255,255,0.08)",
          borderRadius: "12px",
          padding: "1.25rem 1rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          minHeight: "76px"
        }}>
              <img src={src} alt="" width={100} height={32} loading="eager" decoding="async" style={{
            height: "30px",
            width: "auto",
            objectFit: "contain",
            filter: "brightness(0) invert(1)",
            opacity: 0.7
          }} />
            </div>)}
        </div>
      </div>

      <div aria-hidden style={{
      position: "absolute",
      bottom: "48px",
      left: 0,
      right: 0,
      height: "1px",
      background: `linear-gradient(90deg, transparent, ${GOLD} 50%, transparent)`
    }} />
      <div aria-hidden style={{
      position: "absolute",
      bottom: 0,
      left: 0,
      right: 0,
      lineHeight: 0
    }}>
        <svg viewBox="0 0 1440 48" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none" style={{
        display: "block",
        width: "100%",
        height: "48px"
      }}>
          <path d="M0,48 C360,0 1080,0 1440,48 L1440,48 L0,48 Z" fill="#FAF7F1" />
        </svg>
      </div>
    </section>;
}